// extracted by mini-css-extract-plugin
export default {"item":"nq4YjGn3","icon":"jLdRlENh","leftBlock":"nxAiUgO_","amount":"x2kd8DjZ","operationName":"uDw7ob8E","date":"aJl0mknc"};